import { useState } from "react";

export const useSelectedCategory = () => {
  const [selectedCategory, setSelectedCategory] = useState('');
  return { selectedCategory, setSelectedCategory };
};